import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-81fb09c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "responses-content" }
const _hoisted_2 = { class: "responses-content--summary" }
const _hoisted_3 = { class: "responses-content--summary--row--value" }
const _hoisted_4 = { class: "responses-content--summary--row--progress-bar" }

import Skeleton from 'primevue/skeleton'

export default /*#__PURE__*/_defineComponent({
  __name: 'ResponsesSummaryLoading',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
        return _createElementVNode("div", {
          key: i,
          class: "responses-content--summary--row"
        }, [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_unref(Skeleton), {
              height: "1.3rem",
              width: "78%"
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(Skeleton), {
              height: "0.625rem",
              width: "100%"
            })
          ])
        ])
      }), 64))
    ])
  ]))
}
}

})